import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { SMSMessage } from "../../../api/types/Chat";
import { LegacyVerifyEmailOtpResponseSuccess } from "../../../api/types/Onboarding";
import { formattedDateTime } from "../../../utils/dateTime";
import { useChatContext } from "../contexts/chat.context";
import ChatAvatar from "./chatAvatar";

const getChatMessageTimeDisplay = (timetoken: number) => {
  const milliseconds = timetoken; //  / 10000;
  const messageTime = new Date(milliseconds);
  const format = 'LLL dd, yyyy h:mmaaa';
  if (messageTime.getDate() === new Date().getDate()) {
    // TODO: needs work
    return formattedDateTime(messageTime, format); //humanReadableTimeDuration(milliseconds, true);
  }
  return formattedDateTime(messageTime, format);
}

type TSMSConversationMessageProps = {
  message: SMSMessage;
  messageClass?: string;
  wrapperClass?: string;
}

const SMSConversationMessage: FC<TSMSConversationMessageProps> = ({
  message,
  messageClass = "rounded-md text-heading-gray444 text-sm px-4 py-2",
  wrapperClass = ""
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'chatSection' });
  const { t: tMain } = useTranslation();

  const {
    dataSMSUsers,
  } = useChatContext();

  const messageByMe = message.message_type === 'outbound';
  const loggedInUserData = useSelector((state: { commonReducer: { user: LegacyVerifyEmailOtpResponseSuccess } }) => state.commonReducer.user);

  const senderId = message.driverid;
  const senderMemberName =
    messageByMe
      ? (loggedInUserData?.user?.contactname || loggedInUserData?.user?.userid)
      : dataSMSUsers?.results?.find(user => user.driverid === senderId)?.description;

  return (
    <div className={`relative flex gap-2 items-start justify-start${messageByMe ? ' flex-row-reverse' : ''} ${wrapperClass}`}>

      {/* Avatar */}
      {/* <AppAvatar
        bgColorClass={messageByMe
          ? 'bg-gray-300'
          : 'bg-accent-blue-pale'
        }
        extraClasses="flex-shrink-0"
        initials={avatarInitials}
      /> */}
      <ChatAvatar
        isMe={messageByMe}
        title={senderMemberName || senderId}
      />

      {/* Message */}
      <span className={`relative flex flex-col mb-3 ${messageByMe ? "bg-gray-200" : "bg-accent-blue-pale"} ${messageClass}`}>{/* mb-3 to accommodate the date display */}
        {message?.messagetext}
        <span className={`absolute text-[8px] top-full -mt-0.5 ${messageByMe ? 'right-0' : 'left-0'} text-black/40 whitespace-nowrap`}>
          {getChatMessageTimeDisplay(message.timestampms)}
        </span>
      </span>
    </div>
  );
}
export default SMSConversationMessage;